export interface PostTrialBannerState {
  subscribed: boolean;
  isTrial: boolean;
  subscriptionTrialEnd: string | null;
}

const FOURTEEN_DAYS_MS = 14 * 24 * 60 * 60 * 1000;

export function shouldShowPostTrialBanner(
  state: PostTrialBannerState,
  dismissed: boolean,
  now: Date = new Date()
): boolean {
  if (dismissed) return false;
  if (!state.subscribed) return false;
  if (state.isTrial) return false;
  if (!state.subscriptionTrialEnd) return false;

  const trialEnd = new Date(state.subscriptionTrialEnd);
  if (Number.isNaN(trialEnd.getTime())) return false;
  if (trialEnd > now) return false;

  const elapsedMs = now.getTime() - trialEnd.getTime();
  return elapsedMs <= FOURTEEN_DAYS_MS;
}
